module.exports = __webpack_public_path__ + "static/media/shop.0abc4b7b.png";